import EventFilterWithRouter from './EventFilters';
import './EventFilters.scss';

export default EventFilterWithRouter;
